var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bread-box"},_vm._l((_vm.brands),function(item,index){return _c('span',{class:{primary:item['url']},on:{"click":function($event){return _vm.goTo(item)}}},[(index!=0)?_c('Icon',{attrs:{"type":"ios-arrow-forward"}}):_vm._e(),_vm._v(_vm._s(item.label))],1)}),0)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/yxUIComponent/custom/breadCrumb.vue